<router-outlet></router-outlet>
<datalean-upload-progress *ngIf="isUploading$ | async"></datalean-upload-progress>
